import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import useIntegritySpac from '../hooks/useIntegritySpac';

export const lookupBuilding = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Planta Alberti')},
      {id: 1, name: i18n2._('Planta Santa Cruz')},
      {id: 2, name: i18n2._('Planta Pagola')},
      {id: 3, name: i18n2._('Planta Pilar')},
      {id: 4, name: i18n2._('Cochabamba')},
      {id: 5, name: i18n2._('Casa Central')},
    ],
    key: 'id',
  },
};

export const lookupStatus = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('En Ejecucion')},
      {id: 1, name: i18n2._('Validado')},
      {id: 2, name: i18n2._('Revalidado')},
      {id: 3, name: i18n2._('Baja')},
      {id: 4, name: i18n2._('Calificado')},
    ],
    key: 'id',
  },
};

const SpacGrid = (props: any) => {
  const loadSpac = useIntegritySpac(props.data.key);
  return (
    <IntegrityRoleGrid
      dataSource={loadSpac}
      disabledExport={true}
      autoWidth={false}
      id={['iD_Spac']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}>
      <Column
        caption={i18n2._('SPAC')}
        hidingPriority={4}
        dataField="iD_Spac"
      />
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column caption={i18n2._('Estado')} dataField="status">
        <Lookup
          dataSource={lookupStatus}
          valueExpr="id"
          displayExpr={(item: any) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('GXP')} dataField="gxp" hidingPriority={1} />
      <Column caption={i18n2._('Planta')} dataField="building">
        <Lookup
          dataSource={lookupBuilding}
          valueExpr="id"
          displayExpr={(item: any) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('BP Propietario')} dataField="bpOwner" />
      <Column caption={i18n2._('Observacion')} dataField="observation" />
      <Column caption={i18n2._('Categoria de hardware')} dataField="catSw" />
      <Column
        caption={i18n2._('Colaborador responsable')}
        dataField="respUser"></Column>
      <Column caption={i18n2._('Dueño del sistema')} dataField="sysOwner" />
      <Column caption={i18n2._('Aseg.Calidad')} dataField="qaUnit" />
      <Column caption={i18n2._('Experto Materia')} dataField="smExpert" />
      <Column
        caption={i18n2._('Fecha inicial')}
        dataField="dateStIni"
        hidingPriority={0}
      />
      <Column
        caption={i18n2._('Fecha fin')}
        dataField="dateStFin"
        hidingPriority={1}
      />
      <Column
        caption={i18n2._('Fecha real de inicio')}
        dataField="dateRealIni"
        hidingPriority={2}
      />
      <Column
        caption={i18n2._('Fecha real de Fin')}
        dataField="dateRealFin"
        hidingPriority={3}
      />
      <Column
        caption={i18n2._('Fecha Reval')}
        dataField="dateReval"
        hidingPriority={4}
      />
      <Column
        caption={i18n2._('Proveedor de sistemas')}
        dataField="sysSupplier"
      />
      <Column
        caption={i18n2._('Servicio de IT')}
        dataField="itService"
        hidingPriority={5}
      />
      <Column caption={i18n2._('HSE')} dataField="hse" />
      <Column caption={i18n2._('Activo')} dataField="active" />
      <Column caption={i18n2._('Propietario')} dataField="owner" />
      <Column
        caption={i18n2._('Administrador')}
        dataField="admIng"
        hidingPriority={8}
      />
      <Column
        caption={i18n2._('Fomulario XMLS')}
        dataField="formXls"
        hidingPriority={9}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column
        caption={i18n2._('Motivo')}
        dataField="reason"
        hidingPriority={7}
      />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
        hidingPriority={6}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default SpacGrid;
